import { CalendarEvent } from 'mini-calendar-event-types';
import DateRange from '../store/schema/DateRange';
import { convertDateRangeToDisplayDateRange } from './epochTimeToDisplayDate';
import { DateRange as OwaDateRange, dateRangesOverlap } from 'mini-datetime-utils/lib/DateRange';

/**
 * It goes over the given list of events and returns back
 * only those events that overlap with the passed in date range.
 */
export default function getCalendarEventsOverlappingDateRange(
    calendarEvents: CalendarEvent[],
    dateRange: DateRange,
    inclusiveCheck: boolean = true
): CalendarEvent[] {
    const eventsOverlapping: CalendarEvent[] = [];
    if (!!dateRange) {
        const displayDateRange = convertDateRangeToDisplayDateRange(dateRange);
        for (const event of calendarEvents) {
            const eventDateRange: OwaDateRange = { start: event.Start, end: event.End };
            if (
                dateRangesOverlap(
                    displayDateRange,
                    eventDateRange,
                    inclusiveCheck /* inclusive */
                ) === 0
            ) {
                eventsOverlapping.push(event);
            }
        }
    }
    return eventsOverlapping;
}
